import React from 'react';
import { StyleSheet } from 'react-native';
import { DNAIconStyleProps, DNAText } from '@alucio/lux-ui';
import { CommonIcon, DNAPopover } from 'src/components/DNA';
import { useAppSettings } from 'src/state/context/AppSettings';

const S = StyleSheet.create({
  popoverText: {
    marginHorizontal: 12,
    maxWidth: 300,
  },
})

interface HelpCircleTooltipProps extends DNAIconStyleProps {
  placement?: 'top' | 'bottom' | 'left' | 'right';
  offset?: number;
  popoverText: string;
  iconTestID?: string;
  popoverTextTestID?: string;
}

const HelpCircleTooltip: React.FC<HelpCircleTooltipProps> = (props) => {
  const {
    placement = 'top',
    offset = 2,
    popoverText,
    iconTestID,
    popoverTextTestID,
    ...rest
  } = props;
  const { deviceMode } = useAppSettings();
  const iconSize = deviceMode === 'desktop' ? 20 : 24;

  return (
    <DNAPopover placement={placement}>
      <DNAPopover.Anchor>
        <CommonIcon variant="help-circle" testID={iconTestID} width={iconSize} height={iconSize} {...rest} />
      </DNAPopover.Anchor>
      <DNAPopover.Content offset={offset}>
        <DNAText
          colorMode="dark"
          testID={popoverTextTestID}
          style={S.popoverText}
        >
          {popoverText}
        </DNAText>
      </DNAPopover.Content>
    </DNAPopover>
  )
}

export default HelpCircleTooltip;
